import * as React from "react";
import ISvgProps from "../../../SvgLoader/ISvgProps";
function SvgGiftCards(props: ISvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={60}
      height={60}
      viewBox="11 12 45 35"
      fill="none"
      {...props}
    >
      <path
        stroke={props.primaryColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.512}
        d="M14 25.047c0-4.736 0-7.105 1.472-8.575C16.942 15 19.312 15 24.047 15h13.395c4.735 0 7.104 0 8.575 1.472 1.471 1.47 1.471 3.84 1.471 8.575v6.697c0 4.735 0 7.105-1.471 8.575-1.47 1.472-3.84 1.472-8.575 1.472H24.047c-4.736 0-7.105 0-8.575-1.472C14 38.849 14 36.479 14 31.744zM30.744 15v26.79M14 30.07h33.488"
      />
      <path
        stroke={props.secondaryColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M30.744 30.07c0-5.04-10.046-12.793-10.046-5.184 0 2.622 1.277 5.184 4.186 5.184zm0 0c0-5.04 10.047-12.793 10.047-5.184 0 2.622-1.278 5.184-4.186 5.184zm0 0 5.023 5.023m-5.023-5.023-5.023 5.023"
      />
      <circle cx={48.326} cy={39.279} r={4.186} fill="#fff" />
      <path
        fill="#2BBF9F"
        d="M48.465 45a5.581 5.581 0 1 1 0-11.163 5.581 5.581 0 0 1 0 11.163m-.556-3.349 3.946-3.946-.79-.79-3.156 3.158-1.58-1.58-.788.79z"
      />
    </svg>
  );
}
export default SvgGiftCards;
